const initialState = {
    orders: [],

    
    inputUniqueCode: '',
    inputUserName: '', 
    inputMobile: '',
};

const orders = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_ORDERS':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default orders;
